import React, { useEffect, useState } from 'react';

function Maintenance() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    // Load site contact info from settings
    try {
      const savedSettings = localStorage.getItem('admin_settings');
      if (savedSettings) {
        const parsed = JSON.parse(savedSettings);
        setSettings(parsed);
      }
    } catch (error) {
      console.error('Failed to load settings:', error);
    }
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center px-4 py-12">
      <div className="max-w-2xl w-full text-center">
        {/* Icon/Logo */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full"></div>
            <div className="relative w-24 h-24 md:w-32 md:h-32 bg-gradient-to-br from-primary via-primary-dark to-secondary rounded-full flex items-center justify-center shadow-2xl">
              <svg className="w-12 h-12 md:w-16 md:h-16 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Main Message */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 md:mb-6">
          Site Currently Not Available
        </h1>
        
        <div className="w-24 h-1 bg-gradient-to-r from-primary via-primary-dark to-secondary mx-auto mb-6 md:mb-8 rounded-full"></div>

        <p className="text-lg md:text-xl text-gray-600 mb-8 md:mb-10 leading-relaxed">
          We're currently performing maintenance to improve your experience. 
          <br className="hidden md:block" />
          Please check back soon.
        </p>

        {/* Decorative Elements */}
        <div className="flex justify-center gap-2 mb-8 md:mb-10">
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-primary-dark rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-secondary rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
        </div>

        {/* Additional Info */}
        <div className="bg-white/80 backdrop-blur-sm rounded-xl md:rounded-2xl border-2 border-gray-200 shadow-lg p-6 md:p-8">
          <p className="text-sm md:text-base text-gray-500 mb-4">
            If you need immediate assistance, please contact us:
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            {settings?.site_email && (
              <>
                <a 
                  href={`mailto:${settings.site_email}`} 
                  className="flex items-center gap-2 text-primary hover:text-primary-dark font-semibold transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span>{settings.site_email}</span>
                </a>
                {settings?.site_phone && <span className="hidden sm:inline text-gray-300">|</span>}
              </>
            )}
            {settings?.site_phone && (
              <a 
                href={`tel:${settings.site_phone}`} 
                className="flex items-center gap-2 text-primary hover:text-primary-dark font-semibold transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>{settings.site_phone}</span>
              </a>
            )}
            {(!settings?.site_email && !settings?.site_phone) && (
              <p className="text-sm text-gray-500">Contact information not available</p>
            )}
          </div>
        </div>

        {/* Footer */}
        <p className="mt-8 md:mt-10 text-xs md:text-sm text-gray-400">
          We apologize for any inconvenience caused.
        </p>
      </div>
    </div>
  );
}

export default Maintenance;

